<ng-container *transloco="let t">
  <app-page-template [showFooter]="false" [slateBackground]="true">

      <app-my-tracey-page-header [key]="'app.common.back'" (onBackCallback)="goBack()" [hideDefault]="true">
        <div slot="headerContent" (click)="goBack()" class="d-flex align-items-center w-100 justify-content-between justify-content-md-start">
                <div class="color-slate-600 pe-3">
                    Order #{{registration?.id}}
                </div>
                <app-amount-status-badge [amountStatus]="amountStatus"/>
        </div>
    </app-my-tracey-page-header>
    <div class="container scrollable-md-container">

    @if (isMobile) {
      <div class="d-flex flex-column gap-3 h-100 pt-10 pb-50">
        <ng-template [ngTemplateOutlet]="summary"></ng-template>
        <ng-template [ngTemplateOutlet]="orderItems"></ng-template>
        <ng-template [ngTemplateOutlet]="documents"></ng-template>
      </div>
    } @else {
      <div class="row mt-4 pb-300-100">
        <p class="title mb-2"> {{ t('my.tracey.order.summary') }} </p>
        <div class="row">
          <div class="col-md-custom-70 d-flex flex-column gap-3">
            <ng-template [ngTemplateOutlet]="orderWarningInfo"></ng-template>
            <ng-template [ngTemplateOutlet]="summary"></ng-template>
            <ng-template [ngTemplateOutlet]="orderItems"></ng-template>
          </div>
          <div class="col-md-custom-30 d-flex flex-column gap-3">
            <ng-template [ngTemplateOutlet]="documents"></ng-template>
          </div>
        </div>
      </div>
    }

    </div>

    <ng-template #summary>
      <div class="d-flex flex-column gap-2">
        <p *ngIf="isMobile" class="title"> {{ t('my.tracey.order.summary') }} </p>
        <div class="section">
          <div class="flex-grow-1 overflow-hidden p-12">
            <div class="d-flex justify-content-between align-items-center gap-2">
              <p class="fw-semibold fs-18">
                <app-language-output
                  [hrLabel]="event?.name"
                  [enLabel]="event?.nameEng"
                  [itLabel]="event?.nameIta"
                  [siLabel]="event?.nameSlo"
                  [srLabel]="event?.nameSr"
                  [bsLabel]="event?.nameBs"
                  [defaultLanguage]="event?.defaultLanguage"
                  [languages]="languages">
                </app-language-output>
              </p>
            </div>
            <p class="fs-16 color-slate-600">
              <app-language-output
                [hrLabel]="race?.name"
                [enLabel]="race?.nameEng"
                [itLabel]="race?.nameIta"
                [siLabel]="race?.nameSlo"
                [srLabel]="race?.nameSr"
                [bsLabel]="race?.nameBs"
                [defaultLanguage]="event?.defaultLanguage"
                [languages]="languages">
              </app-language-output>
            </p>
          </div>
          <div class="divider-horizontal"></div>
          <div class="d-flex flex-column gap-2 p-12">
            <div class="d-flex justify-content-between align-items-center">
              <p class="color-slate-600">{{ t('my.tracey.order.total.amount') }}</p>
              <p class="fw-600">
                {{registration!.totalAmountWithDiscount |  myCurrency:registration!.currencyCode:true}}
              </p>
            </div>
            <div *ngIf="amountStatus === AmountStatus.EXACT" class="d-flex justify-content-between align-items-center">
                         <p class="color-slate-600">{{ t('my.tracey.order.paid.amount') }}</p>
                         <p class="color-slate-600">
                            {{registration!.totalAmountWithDiscount |  myCurrency:registration!.currencyCode:true}}
                        </p>
            </div>
             <div *ngIf="amountStatus !== AmountStatus.EXACT" class="d-flex justify-content-between align-items-center color-slate-600 section-mobile grey">
                         <p>{{ t('my.tracey.order.due.by') }}</p>
                          <app-event-date-display [start]="registration?.endDateForPayment"/>
            </div>
            <div *ngIf="!isMobile" class="divider-horizontal margin-8"></div>
           <div class="d-flex justify-content-between align-items-center">
                <p>{{ t('my.tracey.order.outstanding.balance') }}</p>
                <p class="fs-20 fw-semibold"> {{(amountStatus === AmountStatus.EXACT ? 0 : registration!.totalAmountWithDiscount )|  myCurrency:registration!.currencyCode:true}}</p>
           </div>

                       @if (isMobile) {
                         <ng-template [ngTemplateOutlet]="orderWarningInfo"></ng-template>
                       } @else if(!isMobile && amountStatus !== AmountStatus.EXACT && isPayable){
                         <app-button-alt
                           [text]="(amountStatus === AmountStatus.NOT_PAID
                             ? t('app.register.to.race.proceed.to.payment')
                             : t('my.tracey.order.pay.remaining', {remainingAmount: registration!.totalAmountWithDiscount ?? '0',  currency: registration!.currencyCode ?? ''})) | uppercase"
                           [buttonHeight]="'44px'"
                           [isFullWidth]="true"
                           (onClickCallback)="goToCompletePayment()"
                           additionalClass="my-2">
                         </app-button-alt>
                       }


                     </div>
                   </div>
                 </div>
               </ng-template>

               <ng-template #orderItems>
               @if (showOrderItemsSection) {
                     <div class="d-flex flex-column gap-2">
                   <p class="title"> {{ t('my.tracey.order.order.items') }} </p>
                    <div class="section">
                    @for (competitor of competitors; track $index;let isLast = $last) {
                     <app-competitor-order-item
                        [competitor]="competitor"
                        [currencyCode]="registration?.currencyCode ?? ''"
                        [isTeam]="registration?.teamRegistration ?? false"
                        [languages]="languages">
                     </app-competitor-order-item>
                 }
                 @if (registration?.traceyFeeAmount) {
                    <div class="px-12 pb-2">
                        <div class="d-flex justify-content-between align-items-center flex-grow-1">
                            <p class="fw-400 color-slate-600 fs-14">
                                {{t('app.register.to.race.tracey.fee')}}:
                            </p>
                                <p class="fw-semibold">
                                    {{ (registration?.traceyFeeAmount ?? 0) |  myCurrency:registration?.currencyCode:true }}
                             </p>
                        </div>
                    </div>
                   }
                 </div>
                 </div>
               }
               </ng-template>

               <ng-template #documents>
                @if (registration?.hasReceipt || registration?.hasInvoice){
                 <div class="d-flex flex-column gap-2 section-mobile p-md-3">
                   <p class="title"> {{ t('my.tracey.order.documents') }} </p>
                   @if (registration?.hasReceipt) {
                   <div class="cursor-pointer" (click)="downloadReceipt()">
                     <ng-template [ngTemplateOutlet]="dropdown" [ngTemplateOutletContext]="{
                     title: t('my.tracey.order.download.receipt'),
                     fileType: 'receipt'
                     }"></ng-template>
                   </div>

                   } @else if (registration?.hasInvoice) {
                   <div class="cursor-pointer" (click)="downloadInvoice()">
                     <ng-template [ngTemplateOutlet]="dropdown" [ngTemplateOutletContext]="{
                     title: t('my.tracey.order.download.invoice'),
                     fileType: 'invoice'
                     }"></ng-template>
                   </div>
                   }
                 </div>
                 }
               </ng-template>


               <ng-template #dropdown let-title="title">
                 <div class="dropdown-wrapper">
                   <div class="section light-grey-md-up d-flex justify-content-between align-items-center p-16 gap-3 border-light-gray">
                     <p> {{ title }}</p>
                     <div class="cursor-pointer">
                       <img src="assets/icons/icons-alt/download.svg" alt="Icon" class="card-body__icon" style="justify-self: center; height: 23px; width: 23px;"/>
                     </div>

                   </div>
                 </div>
               </ng-template>



               <ng-template #orderWarningInfo>
                 <div *ngIf="amountStatus !== AmountStatus.EXACT" class="d-flex align-items-start warning-info"
                      [ngClass]="{'underpaid': amountStatus === AmountStatus.UNDERPAID}">
                   <img src="assets/icons/icons-alt/{{ amountStatus === AmountStatus.UNDERPAID ? 'warning-icon-blue.svg' : 'warning-icon-orange.svg'}}"
                    alt="Info" class="card-body__icon pe-2"/>
                   <div class="fs-14">
                       <p class="bolded" *ngIf="!isMobile">
                         {{ t('my.tracey.order.state.' + amountStatus) | uppercase}} </p>
                       <p>
                        {{
                           t('my.tracey.order.warning.description.state.' + amountStatus)
                         }}
                         @if (amountStatus === AmountStatus.UNDERPAID) {
                          {{registration!.totalAmountWithDiscount ?? '0'}} {{registration!.currencyCode ?? ''}}
                         }
                       </p>
                   </div>
                 </div>
               </ng-template>

               @if (isMobile && isPayable) {
               <div slot="footer" class="footer">
                 <footer class="footer-container">
                      <app-button-alt
                           [text]="(amountStatus  === AmountStatus.NOT_PAID
                             ? t('app.register.to.race.proceed.to.payment')
                             : t('my.tracey.order.pay.remaining', {remainingAmount: registration!.totalAmountWithDiscount ?? '0',  currency: registration!.currencyCode ?? ''})) | uppercase"
                       [buttonHeight]="'44px'"
                       [isFullWidth]="true"
                       (onClickCallback)="goToCompletePayment()"
                       additionalClass="my-2">
                       </app-button-alt>
                 </footer>
               </div>
               }
             </app-page-template>
           </ng-container>
